import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropdown-trigger" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "Teams", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-filter",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_4 = {
  class: "dropdown-menu",
  role: "menu"
}
const _hoisted_5 = { class: "dropdown-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.teams.length)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        ref: "dropdown",
        class: ["dropdown is-right", { 'is-active': _ctx.dropdownActive }]
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("button", {
            class: "button",
            "aria-haspopup": "true",
            "aria-controls": "dropdown-menu",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropdownActive = !_ctx.dropdownActive))
          }, [
            _hoisted_2,
            _hoisted_3
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.teams, (team, index) => {
              return (_openBlock(), _createBlock("label", {
                class: "checkbox py-2 px-4",
                key: team.id,
                style: [{"white-space":"nowrap","width":"100%"}, { 'border-top': index === 0 ? 'none' : '1px solid #dbdbdb' }]
              }, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  name: "teamsRoute",
                  value: team.id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.teamsRoute = $event))
                }, null, 8, ["value"]), [
                  [_vModelCheckbox, _ctx.teamsRoute]
                ]),
                _createTextVNode(" " + _toDisplayString(team.name), 1)
              ], 4))
            }), 128))
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}